// extracted by mini-css-extract-plugin
export default {"row":"b8kDB","textNoMargin":"_4CIyB","textLineHeight":"O+yBt","preWrap":"CBeQs","ellipsis":"_6ldKr"};